import { createSvgIcon } from '@mui/material/utils';

export const MergeCells = createSvgIcon(
  <g>
    <g clipPath="url(#clip0_9077_66)">
      <path d="M24 0H0V24H24V0Z" fillOpacity="0.01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2.5C1 1.67158 1.67158 1 2.5 1H9.5C10.3284 1 11 1.67159 11 2.5V7C11 7.55228 10.5523 8 10 8C9.44772 8 9 7.55228 9 7V3H3V21H9V17C9 16.4477 9.44772 16 10 16C10.5523 16 11 16.4477 11 17V21.5C11 22.3284 10.3284 23 9.5 23H2.5C1.67159 23 1 22.3284 1 21.5V2.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 2.5C13 1.67159 13.6716 1 14.5 1H21.5C22.3284 1 23 1.67159 23 2.5V21.5C23 22.3284 22.3284 23 21.5 23H14.5C13.6716 23 13 22.3284 13 21.5V17C13 16.4477 13.4477 16 14 16C14.5523 16 15 16.4477 15 17V21H21V3H15V7C15 7.55228 14.5523 8 14 8C13.4477 8 13 7.55228 13 7V2.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 12C13 11.4477 13.4477 11 14 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H14C13.4477 13 13 12.5523 13 12Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 12C1.5 11.4477 1.94772 11 2.5 11H10C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13H2.5C1.94772 13 1.5 12.5523 1.5 12Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0814 8.92912C17.4719 9.31965 17.4719 9.95281 17.0813 10.3433L15.402 12.0227L17.0813 13.7021C17.4719 14.0926 17.4719 14.7257 17.0814 15.1163C16.6909 15.5068 16.0577 15.5068 15.6672 15.1163L14.8717 14.3209L13.2807 12.7298C12.8902 12.3393 12.8902 11.7062 13.2807 11.3156L15.6671 8.92912C16.0577 8.5386 16.6908 8.5386 17.0814 8.92912Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.98039 8.92912C7.37092 8.5386 8.00408 8.5386 8.39461 8.92912L10.7811 11.3156C10.9686 11.5032 11.074 11.7575 11.074 12.0227C11.074 12.2879 10.9686 12.5423 10.7811 12.7298L9.19011 14.3208L8.39458 15.1163C8.00405 15.5068 7.37088 15.5068 6.98037 15.1163C6.58986 14.7257 6.58988 14.0926 6.98042 13.7021L7.77589 12.9066L8.65979 12.0227L6.98039 10.3433C6.58987 9.95281 6.58987 9.31965 6.98039 8.92912Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_9077_66">
        <rect width="24" height="24" />
      </clipPath>
    </defs>
  </g>,

  'mergeCells',
);
